import React from "react";
import { Box } from "@mui/material";


const UnknownSearchField = ({ options }) => {
  const { label, type } = options;
  return (
    <Box sx={{ backgroundColor: "red", color: "yellow", flex: "1 1 auto" }}>{type} ("{label}")</Box>
  );
}

export default UnknownSearchField;
